import { Avatar, Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { SearchUsers } from 'screens/Admin/components';

const Filters = ({ owner, setOwner }) => {
  return (
    <Row start gap="30px" pad="12px 24px" noFlex>
      <Col>
        <Text marg="0 16px 4px" b2 med>
          Filter by owner
        </Text>

        <Row noFlex wid="427px">
          <SearchUsers
            placeholder="Search athletes, fans or teams..."
            selected={owner}
            handleSelect={setOwner}
            noRounded
          />

          {owner && (
            <Row start between wid="100%" center>
              <Row noFlex center>
                <Avatar small user={owner} />

                <Col marg="0 0 0 8px" noFlex>
                  <Text>{owner?.name}</Text>

                  <Text c1 col={theme.GREY_60}>
                    @{owner?.username}
                  </Text>
                </Col>
              </Row>

              <Clickable onClick={() => setOwner(null)}>
                <Icon type="close" dimensions={14} />
              </Clickable>
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default Filters;
